var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-state-box"},_vm._l((_vm.icons),function(icon){return _c('span',{key:icon,staticClass:"icon-warn",class:_vm._f("stateClass")(_vm.data.state,true)},[_c('em',{staticClass:"icon iconfont",class:icon})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }